export default __webpack_public_path__ + "static/media/Cryptolocally.68327a2b.png";